import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import UpdateIcon from '@material-ui/icons/Update';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import DeleteIcon from '@material-ui/icons/Delete';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import SaveIcon from '@material-ui/icons/Save';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import moment from 'moment';
import Row from './row';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import environment from '../../environment';
import { instanceAxios } from '../../InstanceAxios';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import FilterIcon from '@material-ui/icons/FilterList';

const useStyles = (theme) => ({
  root: {
    overflow: 'hidden',
    width: '95%',
  },
  button: {
    margin: theme.spacing(1),
  },
  selectTipo: {
    width: 200,
  },
  paper: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '80%',
    height: '80%',
    overflow: 'auto',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loading: {
    marginLeft: '50%',
  },
});

class AssinaturasComponent extends Component {
  constructor() {
    super();
    this.axios = instanceAxios(localStorage.getItem('toobiauth'));
  }

  state = {
    assinaturas: [],
    assinatura: {},
    originalassinaturas: [],
    filterText: '', // Filter text
    isModalOpen: false, // Modal open state
    modalPosition: { top: 0, left: 0 }, // Position of the modal
    modalColumnId: null,
    orderBy: '', // Coluna pela qual estamos ordenando
    planosAssinaturas: [],
    planoSelecionado: { id_plano_iugu: '', valor: 0, descricao: '' },
    qtdAssinatura: 0,
    limit: 10,
    page: 0,
    columns: [
      {
        id: 'expand',
        label: '',
        minWidth: 40,
        align: 'center',
        filterable: false,
      },
      {
        id: `"User.nome"`,
        label: 'Usuário',
        minWidth: 70,
        align: 'center',
        filterable: true,
      },
      {
        id: `"status"`,
        label: 'Status',
        minWidth: 70,
        align: 'center',
        filterable: true,
      },
      {
        id: `"createdAt"`,
        label: 'Data início',
        minWidth: 70,
        align: 'center',
        filterable: true,
      },
      {
        id: `"updatedAt"`,
        label: 'Data Inativação',
        minWidth: 70,
        align: 'center',
        filterable: true,
      },
      {
        id: `"id_plano_assinatura"`,
        label: 'Plano',
        minWidth: 170,
        align: 'center',
        filterable: true,
      },
      {
        id: `"id_plano_assinatura"`,
        label: 'Valor',
        minWidth: 70,
        align: 'center',
        filterable: true,
      },
      {
        id: 'data_vencimento',
        label: 'Validade',
        minWidth: 70,
        align: 'center',
        filterable: true,
      },
      {
        id: 'editarAssinatura',
        label: 'Editar',
        minWidth: 70,
        align: 'center',
        filterable: false,
      },
      {
        id: 'cancelar',
        label: 'Cancelar',
        minWidth: 70,
        align: 'center',
        filterable: false,
      },
    ],
    busca: '',
    openAlert: false,
    msgAlert: false,
    typeAlert: false,
    openModal: false,
    ready: false,
    idOrder: '',
    order: 'asc',
    cupom: '',
    status: 'Todos',
    statusOptions: [
      { label: 'Todos', value: 'Todos' },
      { label: 'Ativa', value: 'Ativa' },
      { label: 'Suspensa', value: 'Suspensa' },
      { label: 'Expirada', value: 'Expirada' },
      { label: 'Cancelada', value: 'Cancelado' },
    ],
  };

  atualizarAssinatura = async (n, l, p, io, o, s) => {
    this.setState({ ready: false });
    await this.axios
      .get(
        `${environment}/listarAssinaturas?nome=${n}&limit=${l}&page=${p}&campoOrdenacao=${io}&ordem=${o}&status=${s}`
      )
      .then((res) => {
        const assinaturas = res.data.rows;
        const qtdAssinatura = res.data.count;
        this.setState({ originalassinaturas: assinaturas });
        this.setState({ assinaturas });
        this.setState({ qtdAssinatura });
        this.setState({ ready: true });
      })
      .catch((err) => {
        this.setState({ assinaturas: [] });
        this.setState({ qtdAssinatura: 0 });
        this.setState({ ready: true });
      });
  };

  atualizarPlanos = async () => {
    this.setState({ ready: false });
    await this.axios
      .get(`${environment}/listarPlanos`)
      .then((res) => {
        console.log(res.data);
        this.setState({ planosAssinaturas: res.data });
        this.setState({ ready: true });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ planosAssinaturas: [] });
        this.setState({ ready: true });
      });
  };

  componentWillMount() {
    this.atualizarAssinatura('', 10, 0, '', '', 'Todos');
    this.atualizarPlanos();
  }

  handleBusca = async (event) => {
    this.setState({ busca: event.target.value });
    this.atualizarAssinatura(
      event.target.value,
      this.state.limit,
      this.state.page,
      this.state.idOrder,
      this.state.order,
      this.state.status
    );
  };

  updateAlert = (msgAlert, typeAlert, openAlert) => {
    this.setState({ msgAlert, typeAlert, openAlert });
  };

  updateModal = (openModal, assinatura) => {
    this.setState({ assinatura });
    this.setState({ planoSelecionado: assinatura.PlanoAssinatura });
    this.setState({ cupom: null });
    this.setState({ openModal });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
    this.atualizarAssinatura(
      this.state.busca,
      this.state.limit,
      newPage,
      this.state.idOrder,
      this.state.order,
      this.state.status
    );
  };

  handleChangeRowsPerPage = (event) => {
    const limit = parseInt(event.target.value, 10);
    this.setState({ limit });
    this.setState({ page: 0 });
    this.atualizarAssinatura(
      this.state.busca,
      limit,
      this.state.page,
      this.state.idOrder,
      this.state.order,
      this.state.status
    );
  };

  handleClickCancelar = async (idUsuario) => {
    this.updateAlert('Assinatura a ser canceçada aguarde!', 'waning', false);
    await this.axios
      .get(`${environment}/cancelarAssinatura/${idUsuario}`)
      .then((res) =>
        this.updateAlert('Assinatura cancelada com sucesso!', 'success', true)
      )
      .catch((err) =>
        this.updateAlert('Erro ao cancelar assinatura', 'error', true)
      );
  };

  handleChangeStatus = async (event) => {
    this.setState({ status: event.target.value, page: 0, limit: 10 });
    this.atualizarAssinatura(
      this.state.busca,
      10,
      0,
      this.state.idOrder,
      this.state.order,
      event.target.value
    );
  };

  handleClickSalvar = async () => {
    this.setState({ openModal: false, ready: false });
    await this.axios
      .post(`${environment}/alterarPlanoAssinaturaUsuario`, {
        idUsuario: this.state.assinatura.id_usuario,
        idPlano: this.state.planoSelecionado.identificador_iugu,
        cupom: this.state.cupom,
      })
      .then((res) => {
        this.updateAlert('Assinatura alterada com sucesso!', 'success', true);
        this.setState({ cupom: '' });
        this.atualizarAssinatura(
          this.state.busca,
          this.state.limit,
          this.state.page,
          this.state.idOrder,
          this.state.order,
          this.state.status
        );
      })
      .catch((err) => {
        const msg =
          err.response && err.response.data
            ? err.response.data.message
            : 'Erro ao alterar assinatura';
        this.updateAlert(msg, 'error', true);
        this.setState({ ready: true, cupom: '' });
      });
  };

  setIdOrder = (idOrder) => {
    // Checando se Não é a coluna Editar
    if (
      idOrder === 'editar' ||
      idOrder === 'expand' ||
      idOrder === 'cancelar' ||
      idOrder === 'mudarStatus'
    )
      return;
    let order;
    // Checando se é o mesmo atual
    if (idOrder === this.state.idOrder) {
      order = this.state.order === 'asc' ? 'desc' : 'asc';
      this.setState({ order });
    } else {
      order = 'asc';
      this.setState({ order, idOrder });
    }

    this.atualizarAssinatura(
      this.state.busca,
      this.state.limit,
      this.state.page,
      idOrder,
      order,
      this.state.status
    );
  };

  openModal = (event, columnid) => {
    this.setState({ filterText: '' });
    const rect = event.target.getBoundingClientRect();
    this.setState({
      isModalOpen: true,
      modalPosition: { top: rect.bottom, left: rect.left },
      modalColumnId: columnid,
    });
  };

  handleFilterTextChange = (event) => {
    this.setState({ filterText: event.target.value });
  };

  // Function to filter the table data
  filterTable = () => {
    this.setState({ isModalOpen: false });
    const { assinaturas, filterText, modalColumnId } = this.state;
    const filteredDas = assinaturas.filter((item) => {
      const value = this.getValueColumnId(modalColumnId, item);
      return (
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase())
      );
    });
    // Update the table data with filtered data
    this.setState({ assinaturas: filteredDas });
  };

  getValueColumnId(columnId, rowData) {
    columnId = columnId.replace(/"/g, '');
    console.log(columnId);
    const parts = columnId.split('.');
    console.log(rowData);
    console.log(parts);
    let result = null;
    for (let part of parts) {
      if (result === null) {
        // If result is null, assign the global object to result
        result = rowData[part];
      } else {
        // If result is not null, access the property
        result = result[part];
      }
    }
    console.log(result);
    return result;
  }
  clearFilter = () => {
    this.setState({ isModalOpen: false });
    this.setState({
      filterText: '',
      assinaturas: this.state.originalassinaturas,
    });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  handleRequestSort = (property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  sortTable = (property) => {
    const { assinaturas, order } = this.state;
    console.log(property);
    const isAsc = order === 'asc';
    assinaturas.sort((a, b) => {
      let aValue = this.getValueColumnId(property, a);
      let bValue = this.getValueColumnId(property, b);
      // If the property is a string, convert to lowercase for case-insensitive sorting
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    this.setState({ assinaturas });
  };

  render() {
    const { classes } = this.props;

    return (
      <>
        <Modal
          open={this.state.isModalOpen}
          onClose={this.closeModal}
          style={{
            top: this.state.modalPosition.top,
            left: this.state.modalPosition.left,
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '5px',
              width: '300px',
            }}
          >
            <TextField
              label="Filtrar"
              variant="outlined"
              value={this.state.filterText}
              onChange={this.handleFilterTextChange}
              fullWidth
            />
            <Button
              variant="contained"
              color="primary"
              onClick={this.filterTable}
              style={{ marginTop: '10px' }}
            >
              Filtrar
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={this.clearFilter}
              style={{ marginTop: '10px', marginLeft: '5px', width: 70 }}
            >
              Limpar
            </Button>
          </div>
        </Modal>
        <Snackbar
          open={this.state.openAlert}
          autoHideDuration={6000}
          onClose={() => this.updateAlert('', '', false)}
        >
          <Alert
            severity={this.state.typeAlert}
            onClick={() => this.updateAlert('', '', false)}
          >
            {this.state.msgAlert}
          </Alert>
        </Snackbar>
        <div align="center">
          <h1>Assinaturas</h1>
        </div>
        <Paper className={classes.root}>
          <Collapse in={this.state.ready}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                padding: 10,
              }}
            >
              <FormControl variant="outlined">
                <InputLabel>Status</InputLabel>
                <Select
                  value={this.state.status}
                  onChange={this.handleChangeStatus}
                  label="status"
                  style={{ minWidth: 100 }}
                >
                  {this.state.statusOptions.map((so) => (
                    <MenuItem value={so.value}>{so.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                id="busca"
                label="Busca"
                value={this.state.busca}
                onChange={this.handleBusca}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {this.state.columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      sortDirection={
                        this.state.orderBy === column.id
                          ? this.state.order
                          : false
                      }
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <TableSortLabel
                          active={this.state.orderBy === column.id}
                          direction={
                            this.state.orderBy === column.id
                              ? this.state.order
                              : 'asc'
                          }
                          onClick={() => {
                            this.handleRequestSort(column.id);
                            setTimeout(() => {
                              this.sortTable(column.id);
                            }, 200);
                          }}
                        >
                          {column.label}
                        </TableSortLabel>

                        {column.filterable && (
                          <IconButton
                            style={{ marginLeft: -5 }}
                            onClick={(event) =>
                              this.openModal(event, column.id)
                            }
                            aria-label="filtra"
                          >
                            <FilterIcon style={{ width: 16, height: 16 }} />
                          </IconButton>
                        )}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.assinaturas.map((a) => (
                  <Row
                    assinatura={a}
                    updateAlert={this.updateAlert}
                    updateModal={this.updateModal}
                  />
                ))}
              </TableBody>
            </Table>
            <TableFooter>
              <TableRow>
                <TablePagination
                  component="div"
                  style={{ backgroundColor: '#FFF' }}
                  rowsPerPageOptions={[5, 10, 25]}
                  count={this.state.qtdAssinatura}
                  rowsPerPage={this.state.limit}
                  page={this.state.page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Collapse>
          <Collapse in={this.state.ready === false}>
            <CircularProgress className={classes.loading} />
          </Collapse>
        </Paper>
        <Modal
          className={classes.modal}
          open={this.state.openModal}
          onClose={() => this.setState({ openModal: false })}
        >
          <div className={classes.paper}>
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xl={12} xs={12}>
                <div align="center">
                  <h1>Plano de Assinatura</h1>
                </div>
              </Grid>
              <Grid item lg={6} md={6} sm={12} xl={6} xs={12}>
                <TextField
                  fullWidth
                  id="tipoPlano"
                  variant="outlined"
                  select
                  label="Plano"
                  value={this.state.planoSelecionado.id_plano_iugu}
                  onChange={(event) => {
                    const ps = this.state.planosAssinaturas.filter((pl) => {
                      if (pl.id_plano_iugu === event.target.value) {
                        return pl;
                      }
                    });
                    this.setState({ planoSelecionado: ps[0] });
                  }}
                >
                  {this.state.planosAssinaturas.map((pa) => (
                    <MenuItem key={pa.id_plano_iugu} value={pa.id_plano_iugu}>
                      {pa.nome}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item lg={6} md={6} sm={12} xl={6} xs={12}>
                <div align="right">
                  <TextField
                    size="medium"
                    id="valorPlano"
                    label="Valor Plano"
                    variant="outlined"
                    value={`R$${this.state.planoSelecionado.valor / 100}`}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </div>
              </Grid>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xl={12}
                xs={12}
                style={{ paddingTop: '3%' }}
              >
                <TextField
                  fullWidth
                  multiline
                  rows="4"
                  id="descricaoPlano"
                  label="Descrição Plano"
                  variant="outlined"
                  value={this.state.planoSelecionado.descricao}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              style={{ paddingTop: '3%' }}
            >
              <div
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {this.state.assinatura.HistoricoUsoCupoms &&
                this.state.assinatura.HistoricoUsoCupoms.length ? (
                  <>
                    <h2 style={{ fontWeight: 'bold' }}>Cupons Aplicados</h2>
                    <List>
                      {this.state.assinatura.HistoricoUsoCupoms.map((h) => (
                        <ListItem>
                          <ListItemIcon>
                            <CardGiftcardIcon />
                          </ListItemIcon>
                          <ListItemText
                            primary={h.CupomDeDesconto.cupom}
                            secondary={`Válido até ${moment(h.created_at)
                              .add(h.CupomDeDesconto.qtdMeses, 'M')
                              .format('DD/MM/YYYY')}`}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </>
                ) : (
                  <TextField
                    id="cupom"
                    label="CUPOM"
                    variant="outlined"
                    value={this.state.cupom}
                    onChange={(event) =>
                      this.setState({ cupom: event.target.value })
                    }
                    helperText="Cupom ao ser adicionado!!!"
                  />
                )}
              </div>
            </Grid>
            <Grid container>
              <Grid
                item
                lg={6}
                md={6}
                sm={6}
                xl={12}
                xs={12}
                style={{ paddingTop: '10%' }}
              >
                <Button
                  size="medium"
                  variant="contained"
                  color="secondary"
                  onClick={() =>
                    this.handleClickCancelar(this.state.assinatura.id_usuario)
                  }
                  startIcon={<DeleteIcon />}
                >
                  Cancelar
                </Button>
              </Grid>
              <Grid
                item
                lg={6}
                md={6}
                sm={6}
                xl={12}
                xs={12}
                style={{ paddingTop: '10%' }}
              >
                <div align="right">
                  <Button
                    size="medium"
                    variant="contained"
                    color="primary"
                    onClick={() => this.handleClickSalvar()}
                    startIcon={<SaveIcon />}
                  >
                    Salvar
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>
        </Modal>
      </>
    );
  }
}

export default withStyles(useStyles)(AssinaturasComponent);
